/**
 * Sprint D — Maintenance mode landing page.
 *
 * Rendered by MaintenanceGate when `VITE_MAINTENANCE_MODE === "true"`.
 * Always reachable at /maintenance for verification.
 *
 * Design goals:
 *   - Friendly Swedish copy (no technical jargon)
 *   - Estimated end time matches Sunday 04:00–07:00 CEST window default
 *   - No auth, no API calls, no other dependencies
 *   - Renders fast on stale cache (no JS chunks needed beyond this page)
 */

import { Card, CardContent } from "@/components/ui/card";

const DEFAULT_END_TIME = "07:00 (CEST) söndag";

interface MaintenanceProps {
  endTimeLabel?: string;
}

export default function Maintenance({ endTimeLabel = DEFAULT_END_TIME }: MaintenanceProps) {
  return (
    <main
      className="flex min-h-screen flex-col items-center justify-center bg-background p-6"
      role="main"
      aria-labelledby="maintenance-title"
    >
      <Card className="w-full max-w-lg shadow-lg">
        <CardContent className="space-y-4 p-8 text-center">
          <div
            className="text-5xl"
            role="img"
            aria-label="Underhåll pågår"
          >
            🛠️
          </div>

          <h1
            id="maintenance-title"
            className="text-2xl font-semibold tracking-tight"
          >
            Underhåll pågår
          </h1>

          <p className="text-base text-muted-foreground">
            Vi uppdaterar vårt bokningssystem just nu. Du kan inte göra
            bokningar eller ändringar under tiden.
          </p>

          <p className="text-sm text-muted-foreground">
            Vi är tillbaka kring <strong>{endTimeLabel}</strong>.
          </p>

          <hr className="my-2 border-border" />

          <p className="text-xs text-muted-foreground">
            Tack för ditt tålamod. Vid akuta frågor — kontakta din klubb direkt.
          </p>
        </CardContent>
      </Card>
    </main>
  );
}
